import { React, useState, useEffect } from "react";
import {
  Progress,
  Row,
  Col,
  Select,
  Form,
  Button,
  Space,
  Modal,
  Collapse,
  Typography,
  Popconfirm,
  Tooltip,
  Divider,
  Input,
  Tag,
} from "antd";
import { useTranslation } from "react-i18next";
import {
  EditOutlined,
  LoadingOutlined,
  CheckCircleOutlined,
  CloseOutlined,
  UndoOutlined,
  HistoryOutlined,
  EllipsisOutlined,
} from "@ant-design/icons";
import {
  AlertOctagon,
  Calendar,
  Gift,
  Mail,
  Phone,
  MapPin,
  User,
  Hash,
  FileText,
  TrendingUp,
  Map,
  AtSign,
  Briefcase,
  Users,
  Star,
} from "react-feather";
import { useNavigate } from "react-router-dom";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnTable from "../common/adnTable/AdnTable";
import AdnInput from "../common/adnInput/AdnInput";
import AdnAddButton from "../common/adnAddButton/AdnAddButton";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import EmployeeConsultantDetailsForm from "./EmployeeConsultantDetailsForm";
import EmployeeInternalDetailsForm from "./EmployeeInternalDetailsForm";
import AdnDatePicker from "../common/adnDatePicker/AdnDatePicker";
import moment from "moment";
import {
  adnPageSize,
  AssessmentResponses,
  AssessmentResponsesDescriptionEN,
  AssessmentResponsesDescriptionPT,
  dateFormat,
  MonthsPortuguese,
  OfferStatus,
  WorkPlaces,
  EmployeeTabs,
  Departement,
} from "../common/GeneralConfigurations";
import { NameValidation, NoteValidation } from "./EmployeeOfferValidations";
import AdnTextArea from "../common/adnTextArea/AdnTextArea";
import AdnCard from "../common/adnCard/AdnCard";
import { AdnStar } from "../common/adnStar/AdnStar";
import { AppRoutes } from "../../AppRoutes";
import AdnCertificationTable from "../common/adnCertificationTable/AdnCertificationTable";
import "./EmployeeForm.css";
import AdnButton from "../common/adnButton/AdnButton";

//Country Flags
import Argentina from "../../assets/images/country_flags/argentina.svg";
import Brazil from "../../assets/images/country_flags/brazil.svg";
import Bulgary from "../../assets/images/country_flags/bulgary.svg";
import CapeGreen from "../../assets/images/country_flags/capegreen.svg";
import Chile from "../../assets/images/country_flags/chile.svg";
import Colombia from "../../assets/images/country_flags/colombia.svg";
import Cuba from "../../assets/images/country_flags/cuba.svg";
import France from "../../assets/images/country_flags/france.svg";
import Hungary from "../../assets/images/country_flags/hungary.svg";
import Italy from "../../assets/images/country_flags/italy.svg";
import Kazakhstan from "../../assets/images/country_flags/kazakhstan.svg";
import Moldavia from "../../assets/images/country_flags/moldavia.svg";
import Peru from "../../assets/images/country_flags/peru.svg";
import Portugal from "../../assets/images/country_flags/portugal.svg";
import Russia from "../../assets/images/country_flags/russia.svg";
import Tunisia from "../../assets/images/country_flags/tunisia.svg";
import UnitedKingdom from "../../assets/images/country_flags/unitedkingdom.svg";
import Unknown from "../../assets/images/country_flags/unknown.svg";
import CaptionComponent from "../common/adnCaptionComponent/AdnCaptionComponent";
import { getAuthenticatedUserId } from "../../api/ApiUtils";
import { getSetting } from "../../api/SettingApi";

// const { Option } = Select;
const { Text } = Typography;
// const { Panel } = Collapse;

function EmployeeForm({
  consultantForm,
  formTitle,
  criticalSituationsLinkPath,
  isConsultant,
  onTemplateChangeHandle,
  templateQuestions,
  selectedTemplateId,
  careerLevels,
  handleContractType,
  contractTypeList,
  techSpecializedList,
  initialValues,
  managersList,
  humanResList,
  onFormFinish,
  setVisibleModalOffer,
  visibleModalOffer,
  handleFormOffer,
  event,
  setEvent,
  offerData,
  employeeOfferData,
  setOfferHandler,
  disabledDateOffer,
  templates,
  isEditing,
  isSentInquiryEmail,
  isInquiryAnswered,
  disabledDateBirthDate,
  loading,
  openEmailModal,
  inquiryForm,
  submitInquiry,
  getOfferListData,
  fluencyLanguages,
  setFluencyLanguages,
  templateAlreadySelected,
  onQuestion1Change,
  onQuestion2Change,
  onQuestion3Change,
  onQuestion4Change,
  onQuestion5Change,
  onQuestion6Change,
  employeeFollowUpEventData,
  workPlaceList,
  countryList,
  image,
  saveImage,
  handleChangeFollowUpPage,
  totalRecordsFollowUp,
  handleBlurEmail,
  handleBlurName,
  haveAdmissionCti,
  formOffers,
  employeeId,
  onCancelOffersModal,
  handleChangeToCti,
  isCTI,
  onIsConsultantChange,
  isIntegrationEmailSent,
  isProfileEmailSent,
  modalSubmitLoading,
  submitLoading,
  imgLoading,
  haveAdmissionCps,
  handleSelectReferenceBy,
  handleSearchReferenceBy,
  referenceByEmployees,
  referenceByName,
  handleAward,
  isFirstAwardPaid,
  isSecondAwardPaid,
  handleFirstAward,
  handleSecondAward,
  referenceByBlur,
  companySatisfaction,
  projectSatisfaction,
  clientSatisfaction,
  employeeFollowUpEventsCounters,
  employeeOffersCounters,
  tags,
  tagInputRef,
  tagEditInputRef,
  tagInputVisible,
  tagInputValue,
  editTagInputIndex,
  editTagInputValue,
  setTagEditInputIndex,
  setTagEditInputValue,
  handleCloseTag,
  showTagInput,
  handleTagInputChange,
  handleTagInputConfirm,
  handleTagEditInputChange,
  handleTagEditInputConfirm,
  isEmailEnglishLanguages,
  setisEmailEnglishLanguages,
  isEmailSending,
  isFirstMonthAssessmentEmailSent,
  isFirstMonthAssessmentAnswered,
  firstMonthAssessmentQuestions,
  isEmailEnglishLanguage,
  percentage,
  employeeCertificationData,
  isEditEnabled,
  setIsEditEnabled,
  disableEdit,
  saveEditChanges,
  visibleCancelRecommendationsModal,
  setVisibleCancelRecommendationsModal,
  handleCancelUnpaidRecommendations,
  handleCancelEventModal,
  handleUnCancelEvent,
  cancelEventVisible,
  setCancelEventVisible,
  cancelEventForm,
  handleCancelEventFinish,
  assignedToList,
  handleAssignPerson,
  unresolvedModalVisible,
  setUnresolvedModalVisible,
  ShowEditModal,
  handleTransition,
  confirmAssignPerson,
  eventEmployeeId,
  eventAssignedToId,
  handleChangeOffer,
  handleChangeTechSpecializedName,
  techSpecializedName,
  handleOfferDate,
  managerEditPermission,
  inTransition,
  cancelOfferVisible,
  cancelOfferForm,
  setCancelOfferVisible,
  offerFormValues,
  handleCancelOfferModal,
  resignationReasonOptions,
  hasResignationDate,
  handleResignationDateChange,
  showContractHistoryModal,
  handleCloseContractHistoryModal,
  handleShowHistoryModal,
  employeeContractHistory,
  isManager,
  hasCorpDepartureReason,
  departmentList,
}) {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [selectedTab, setSelectedTab] = useState(EmployeeTabs.Details);
  const [settingProfileEmailActive, setSettingProfileEmailActive] = useState(
    []
  );

  const followUpEventsColumns = [
    {
      title: t("employeeForm.table.columns.description"),
      dataIndex: "eventType",
      width: "20%",
    },
    {
      title: t("employeeForm.table.columns.referenceDate"),
      dataIndex: "referenceDate",
      render: (text) =>
        text
          ? MonthsPortuguese[parseInt(moment(text).format("MM"))] +
            " " +
            moment(text).format("YYYY")
          : undefined,
      width: "11%",
    },
    {
      title: t("employeeForm.table.columns.date"),
      dataIndex: "date",
      render: (text, record) =>
        record.date ? moment(record.date).format(dateFormat) : <></>,
      width: "10%",
    },

    {
      title: t("employeeForm.table.columns.assignedTo"),
      dataIndex: "doneByName",
      width: "12%",
      render: (text, record) => (
        <>
          {record.status === 0 || record.status === 1 ? (
            <AdnDropdown
              name="doneByName"
              placeholder={t("employeeForm.table.placeholders.assignPerson")}
              handleChange={(value) => {
                handleAssignPerson(record.id, value);
              }}
              defaultValue={text}
              allowClear={true}
              options={assignedToList}
              disabled={isManager}
            />
          ) : (
            <>{text}</>
          )}
        </>
      ),
    },
    {
      title: t("employeeForm.table.columns.client"),
      dataIndex: "clientLevel",
      render: (text, record) => (
        <Space style={{ width: "100%", justifyContent: "center" }} size="small">
          {text != null ? (
            <>
              <Text>{text}</Text>
              <AdnStar />
            </>
          ) : (
            <b>{t("employeeFormDetails.status.noScore")}</b>
          )}
        </Space>
      ),
      width: "9%",
    },
    {
      title: t("employeeForm.table.columns.company"),
      dataIndex: "companyLevel",
      render: (text, record) => (
        <Space style={{ width: "100%", justifyContent: "center" }} size="small">
          {text != null ? (
            <>
              <Text>{text}</Text>
              <AdnStar />
            </>
          ) : (
            <b>{t("employeeFormDetails.status.noScore")}</b>
          )}
        </Space>
      ),
      width: "9%",
    },
    {
      title: t("employeeForm.table.columns.project"),
      dataIndex: "projectLevel",
      render: (text, record) => (
        <Space style={{ width: "100%", justifyContent: "center" }} size="small">
          {text != null ? (
            <>
              <Text>{text}</Text>
              <AdnStar />
            </>
          ) : (
            <b>{t("employeeFormDetails.status.noScore")}</b>
          )}
        </Space>
      ),
      width: "9%",
    },
    {
      title: t("employeeForm.table.columns.status"),
      dataIndex: "status",
      render(text, record) {
        return {
          props: {
            style: {
              background:
                record.status === 2
                  ? "#00c972"
                  : record.status === 1
                  ? "#ffac2b"
                  : record.status === 3
                  ? "#e2435b"
                  : "",
              color: record.status === 0 ? "black" : "white",
              fontSize: "small",
              textAlign: "center",
            },
          },
          children:
            record.status === 2
              ? t("employeeForm.table.status.done")
              : record.status === 1
              ? t("employeeForm.table.status.notDone")
              : record.status === 3
              ? t("employeeForm.table.status.canceled")
              : t("employeeForm.table.status.notAssigned"),
        };
      },
      width: "8%",
    },
    {
      title: t("employeeForm.table.columns.actions"),
      key: "action",
      render: (text, record) => (
        <>
          {(!isManager || record.doneById === getAuthenticatedUserId()) && (
            <Space style={{ display: "flex", justifyContent: "center" }}>
              {record.status === 0 ? (
                <></>
              ) : (
                <EditOutlined
                  style={{ color: "black", fontSize: "large" }}
                  onClick={() => {
                    navigate(AppRoutes.followUpEventById.createPath(record.id));
                  }}
                />
              )}

              {record.status === 0 || record.status === 1 ? (
                <>
                  <CloseOutlined
                    style={{ color: "red" }}
                    onClick={() => handleCancelEventModal(record)}
                  />
                </>
              ) : record.status === 3 || record.status === 2 ? (
                <Popconfirm
                  title={t("employeeForm.table.tooltips.resetEvent")}
                  onConfirm={() => {
                    handleUnCancelEvent(record.id);
                  }}
                >
                  <UndoOutlined style={{ color: "blue" }} />
                </Popconfirm>
              ) : (
                <></>
              )}
            </Space>
          )}
        </>
      ),
      width: "8%",
    },
  ];

  const offerColumns = [
    {
      title: t("employeeForm.table.columns.type"),
      dataIndex: "offerName",
    },
    {
      title: t("employeeForm.table.columns.referenceDate"),
      dataIndex: "referenceDate",
      render: (text) =>
        text
          ? moment(text).format("DD") +
            " de " +
            MonthsPortuguese[parseInt(moment(text).format("MM"))] +
            " " +
            moment(text).format("YYYY")
          : undefined,
      width: "11%",
    },
    {
      title: t("employeeForm.table.columns.description"),
      dataIndex: "description",
      sorter: true,
    },
    {
      title: t("employeeForm.table.columns.location"),
      dataIndex: "workPlaceId",
      render: (text, record) => {
        const workPlaceName = Object.keys(WorkPlaces).find(
          (key) => WorkPlaces[key] === record.workPlaceId
        );
        if (workPlaceName) {
          const formattedName = workPlaceName.replace(
            /([a-z])([A-Z])/g,
            "$1 $2"
          );
          return formattedName;
        }
        return null;
      },
    },
    {
      title: t("employeeForm.table.columns.offeredAt"),
      dataIndex: "offeredAt",
      sorter: true,
      render: (text, record) => (
        <Space style={{ width: "100%" }} size="small" className="date-cell">
          {text ? (
            <p>{text}</p>
          ) : record.status !== OfferStatus.Delivered &&
            record.status !== OfferStatus.NotDelivered ? (
            <p>-</p>
          ) : (
            <>
              <AdnDatePicker
                className="offer-date-picker"
                name={"offeredAt"}
                placeholder={t("employeeForm.table.placeholders.selectDate")}
                disabledDate={disabledDateOffer}
                format={dateFormat}
                allowClear={true}
                onChange={(value) => {
                  handleOfferDate(value, record);
                }}
              />
            </>
          )}
        </Space>
      ),
    },
    {
      title: t("employeeForm.table.columns.status"),
      dataIndex: "status",
      render: (text, record) =>
        record.status === OfferStatus.Delivered ? (
          <div className="state-tag tag-done">
            {t("employeeFormDetails.status.delivered")}
          </div>
        ) : record.status === OfferStatus.NotDelivered ? (
          <div className="state-tag tag-danger">
            {t("employeeFormDetails.status.notDelivered")}
          </div>
        ) : (
          <div className="state-tag tag-canceled">
            {t("employeeFormDetails.status.canceled")}
          </div>
        ),
    },
    {
      title: t("employeeForm.table.columns.action"),
      key: "action",
      render: (record) => (
        <>
          {!isManager && (
            <Space size="middle">
              {record.status === OfferStatus.NotDelivered ? (
                <>
                  <Tooltip title={t("employeeForm.table.tooltips.edit")}>
                    <EditOutlined
                      style={{ color: "black" }}
                      onClick={() => {
                        formOffers.setFieldsValue(record);
                        ShowEditModal(record);
                      }}
                    />
                  </Tooltip>
                  <Tooltip title={t("employeeFormDetails.tooltips.cancel")}>
                    <CloseOutlined
                      style={{ color: "red" }}
                      onClick={() => handleCancelOfferModal(record)}
                    ></CloseOutlined>
                  </Tooltip>
                </>
              ) : (
                <>
                  <Popconfirm
                    title={t(
                      "employeeFormDetails.messages.resetOfferConfirmation"
                    )}
                    onConfirm={() => {
                      handleChangeOffer(record, OfferStatus.NotDelivered);
                    }}
                  >
                    <Tooltip title={t("employeeFormDetails.tooltips.reset")}>
                      <UndoOutlined style={{ color: "blue" }} />
                    </Tooltip>
                  </Popconfirm>
                </>
              )}
            </Space>
          )}
        </>
      ),
      width: "10%",
    },
  ];

  const constractHistoryColumns = [
    {
      title: t("employeeFormDetails.tableColumns.contractType"),
      dataIndex: "contractTypeName",
      width: "20%",
    },
    {
      title: t("employeeFormDetails.tableColumns.careerLevel"),
      dataIndex: "carrearLevelName",
      width: "20%",
    },
    {
      title: t("employeeFormDetails.tableColumns.department"),
      dataIndex: "department",
      width: "10%",
    },
    {
      title: t("employeeForm.table.columns.date"),
      dataIndex: "date",
      width: "10%",
      render: (date) => moment(date).format("YYYY-MM-DD"),
    },
  ];

  const renderIfTemplateQuestionLoaded = (templateNumber, questionIdx) => {
    return templateQuestions[templateNumber].length !== 0 ? (
      templateQuestions[templateNumber][questionIdx].question
    ) : (
      <LoadingOutlined />
    );
  };

  const translateAssessmentResponse = (value) => {
    let satisfaction;
    switch (value) {
      case AssessmentResponses.VeryDissatisfied:
        satisfaction = isEmailEnglishLanguage
          ? AssessmentResponsesDescriptionEN.VeryDissatisfied
          : AssessmentResponsesDescriptionPT.VeryDissatisfied;
        break;
      case AssessmentResponses.Dissatisfied:
        satisfaction = isEmailEnglishLanguage
          ? AssessmentResponsesDescriptionEN.Dissatisfied
          : AssessmentResponsesDescriptionPT.Dissatisfied;
        break;
      case AssessmentResponses.NotVerySatisfied:
        satisfaction = isEmailEnglishLanguage
          ? AssessmentResponsesDescriptionEN.NotVerySatisfied
          : AssessmentResponsesDescriptionPT.NotVerySatisfied;
        break;
      case AssessmentResponses.Satisfied:
        satisfaction = isEmailEnglishLanguage
          ? AssessmentResponsesDescriptionEN.Satisfied
          : AssessmentResponsesDescriptionPT.Satisfied;
        break;
      case AssessmentResponses.VerySatisfied:
        satisfaction = isEmailEnglishLanguage
          ? AssessmentResponsesDescriptionEN.VerySatisfied
          : AssessmentResponsesDescriptionPT.VerySatisfied;
        break;
    }
    return satisfaction;
  };

  const translateAssessmentResponseToColor = (satisfaction) => {
    let colorSatisfaction;
    let satisfactionInt = parseInt(satisfaction);
    switch (satisfactionInt) {
      case AssessmentResponses.VerySatisfied:
        colorSatisfaction = "#52c41a";
        break;
      case AssessmentResponses.Satisfied:
        colorSatisfaction = "#52c41a";
        break;
      case AssessmentResponses.NotVerySatisfied:
        colorSatisfaction = "#fadb14";
        break;
      case AssessmentResponses.Dissatisfied:
        colorSatisfaction = "#f5222d";
        break;
      case AssessmentResponses.VeryDissatisfied:
        colorSatisfaction = "#f5222d";
        break;
    }
    return colorSatisfaction;
  };

  const getNationalitySVG = (nationalityId) => {
    switch (nationalityId) {
      case 1:
        return <img className="employee-flag" src={Argentina} />;
      case 2:
        return <img className="employee-flag" src={Bulgary} />;
      case 3:
        return <img className="employee-flag" src={Brazil} />;
      case 4:
        return <img className="employee-flag" src={Cuba} />;
      case 5:
        return <img className="employee-flag" src={UnitedKingdom} />;
      case 6:
        return <img className="employee-flag" src={Hungary} />;
      case 7:
        return <img className="employee-flag" src={Italy} />;
      case 8:
        return <img className="employee-flag" src={Kazakhstan} />;
      case 9:
        return <img className="employee-flag" src={Portugal} />;
      case 10:
        return <img className="employee-flag" src={Tunisia} />;
      case 11:
        return <img className="employee-flag" src={Moldavia} />;
      case 12:
        return <img className="employee-flag" src={Russia} />;
      case 13:
        return <img className="employee-flag" src={Peru} />;
      case 14:
        return <img className="employee-flag" src={Chile} />;
      case 15:
        return <img className="employee-flag" src={France} />;
      case 16:
        return <img className="employee-flag" src={CapeGreen} />;
      case 17:
        return <img className="employee-flag" src={Colombia} />;
      default:
        return <img className="employee-flag" src={Unknown} />;
    }
  };

  const filteredCareerLevels = (carrearLevelId) => {
    let filtered = careerLevels.filter((level) => level.id === carrearLevelId);
    if (filtered === undefined || filtered.length <= 0) {
      return "unknown";
    } else {
      return filtered[0].name;
    }
  };

  const filteredDepartments = (departmentId) => {
    let filtered = departmentList.filter(
      (department) => department.id === departmentId
    );
    if (filtered === undefined || filtered.length <= 0) {
      return "unknown";
    } else {
      return filtered[0].name;
    }
  };

  const filteredContractTypes = (contractTypeId) => {
    let filtered = contractTypeList.filter(
      (contract) => contract.id === contractTypeId
    );
    if (filtered === undefined || filtered.length <= 0) {
      return "unknown";
    } else {
      return filtered[0].name;
    }
  };

  const filteredResignationsReasons = (initialValues) => {
    if (initialValues.departureReason) {
      return initialValues.departureReason;
    }

    let filtered = resignationReasonOptions.filter(
      (resignation) => resignation.id === initialValues.resignationReasonId
    );
    if (filtered === undefined || filtered.length <= 0) {
      return "unknown";
    } else {
      return filtered[0].name;
    }
  };

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };

  const handleGender = (gender) => {
    switch (gender) {
      case "F":
        return "Female";
      case "M":
        return "Male";
      default:
        return "Other";
    }
  };

  const filteredCountry = (nationalityId) => {
    let filtered = countryList.filter(
      (country) => country.id === nationalityId
    );
    if (filtered === undefined || filtered.length <= 0) {
      return "unknown";
    } else {
      return filtered[0].name;
    }
  };

  const handleEmailLanguage = (isEmailEnglishLanguage) => {
    if (!isEmailEnglishLanguages.en) {
      return "Portuguese";
    }
    return "English";
  };

  const filteredLocations = (workplaceId) => {
    let filtered = workPlaceList.filter((place) => place.id === workplaceId);
    if (filtered === undefined || filtered.length <= 0) {
      return "unknown";
    } else {
      return filtered[0].name;
    }
  };

  const filteredManagers = (managerId) => {
    let filtered = managersList.filter((manager) => manager.id === managerId);
    if (filtered === undefined || filtered.length <= 0) {
      return "unknown";
    } else {
      return filtered[0].name;
    }
  };

  const getSettingProfileEmailActive = async () => {
    let settingId = "BCCD6F54-9EF7-4DED-8645-F2F02B67DC88";
    getSetting(settingId).then((res) => {
      setSettingProfileEmailActive(res.data);
    });
  };

  useEffect(() => {
    getSettingProfileEmailActive();
  }, []);

  return (
    <>
      <AdnPageTitle title={formTitle} />
      {!isEditEnabled ? (
        <>
          <AdnCard loading={loading}>
            <Row justify="space-between">
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 19 }}
                xl={{ span: 19 }}
                xxl={{ span: 19 }}
              >
                <Row className="employee-general-details">
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 4 }}
                    xxl={{ span: 4 }}
                  >
                    <img src={image} className="employee-image" />
                  </Col>
                  {initialValues && contractTypeList && careerLevels && (
                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 24 }}
                      xl={{ span: 19 }}
                      xxl={{ span: 19 }}
                    >
                      <Row
                        className="employee-general-details-row"
                        align="middle"
                      >
                        <Tooltip
                          title={filteredCountry(initialValues.nationalityId)}
                        >
                          {getNationalitySVG(initialValues.nationalityId)}
                        </Tooltip>
                        <h3>{initialValues.name}</h3>
                      </Row>
                      {isConsultant && (
                        <>
                          <Row
                            className="employee-general-details-row"
                            align="middle"
                          >
                            <h4>
                              {filteredContractTypes(
                                initialValues.contractTypeId
                              )}{" "}
                              /{" "}
                              {filteredCareerLevels(
                                initialValues.carrearLevelId
                              )}
                            </h4>
                            {initialValues.resignationDate !== "" && (
                              <Tooltip
                                title={t("employeeFormDetails.labels.resigned")}
                              >
                                <AlertOctagon color="var(--adnred)" />
                              </Tooltip>
                            )}
                          </Row>

                          <Progress
                            percent={percentage}
                            width={20}
                            strokeWidth={15}
                          />
                          {!hasResignationDate && (
                            <Row style={{ margin: "0.5rem 0" }}>
                              <Col xs={{ span: 24 }} style={{ minHeight: "0" }}>
                                <CaptionComponent
                                  text={
                                    t("employeeFormDetails.labels.nextEvent") +
                                    " " +
                                    employeeFollowUpEventsCounters.nextEmployeeFollowUpEventName +
                                    " | " +
                                    moment(
                                      employeeFollowUpEventsCounters.nextEmployeeFollowUpEventDate
                                    ).format(dateFormat)
                                  }
                                  status={0}
                                  isBold={true}
                                />
                              </Col>
                            </Row>
                          )}
                        </>
                      )}
                    </Col>
                  )}
                </Row>
                {isConsultant && (
                  <Row gutter={16}>
                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 8 }}
                      lg={{ span: 8 }}
                      xl={{ span: 4 }}
                      xxl={{ span: 4 }}
                    >
                      <Row className="consultant-general-item">
                        <Row>
                          <h3>
                            {employeeFollowUpEventsCounters === undefined
                              ? 0
                              : employeeFollowUpEventsCounters.employeeFollowUpEventDone}
                          </h3>
                          <h5>
                            /
                            {employeeFollowUpEventsCounters === undefined
                              ? 0
                              : employeeFollowUpEventsCounters.employeeFollowUpEventUndone +
                                employeeFollowUpEventsCounters.employeeFollowUpEventDone}
                          </h5>
                        </Row>
                        <Col className="consultant-general-item-title">
                          <p>
                            {t("employeeFormDetails.labels.followUpEvents")}
                          </p>
                        </Col>
                      </Row>
                    </Col>

                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 8 }}
                      lg={{ span: 8 }}
                      xl={{ span: 4 }}
                      xxl={{ span: 4 }}
                    >
                      <Row className="consultant-general-item">
                        <Row>
                          <h3>
                            {employeeOffersCounters === undefined
                              ? 0
                              : employeeOffersCounters.employeeOffersGiven}
                          </h3>
                          <h5>
                            /
                            {employeeOffersCounters === undefined
                              ? 0
                              : employeeOffersCounters.employeeOffersGiven +
                                employeeOffersCounters.employeeOffersForGiving}
                          </h5>
                        </Row>
                        <p>{t("employeeFormDetails.labels.offers")}</p>
                      </Row>
                    </Col>

                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 8 }}
                      lg={{ span: 8 }}
                      xl={{ span: 4 }}
                      xxl={{ span: 4 }}
                    >
                      <Row className="consultant-general-item">
                        <Row style={{ gap: "4px" }}>
                          <h3>{companySatisfaction}</h3>
                          <Star width={16} height={16} />
                        </Row>
                        <Col className="consultant-general-item-title">
                          <p>
                            {t(
                              "employeeFormDetails.labels.companySatisfaction"
                            )}
                          </p>
                        </Col>
                      </Row>
                    </Col>

                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 8 }}
                      lg={{ span: 8 }}
                      xl={{ span: 4 }}
                      xxl={{ span: 4 }}
                    >
                      <Row className="consultant-general-item">
                        <Row style={{ gap: "4px" }}>
                          <h3>{projectSatisfaction}</h3>
                          <Star width={16} height={16} />
                        </Row>
                        <Col className="consultant-general-item-title">
                          <p>
                            {t(
                              "employeeFormDetails.labels.projectSatisfaction"
                            )}
                          </p>
                        </Col>
                      </Row>
                    </Col>

                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 8 }}
                      lg={{ span: 8 }}
                      xl={{ span: 4 }}
                      xxl={{ span: 4 }}
                    >
                      <Row className="consultant-general-item">
                        <Row style={{ gap: "4px" }}>
                          <h3>{clientSatisfaction}</h3>
                          <Star width={16} height={16} />
                        </Row>
                        <Col className="consultant-general-item-title">
                          <p>
                            {t("employeeFormDetails.labels.clientSatisfaction")}
                          </p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )}
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 5 }}
                xl={{ span: 5 }}
                xxl={{ span: 5 }}
              >
                <Row gutter={16} justify="end">
                  <Col>
                    <Button
                      onClick={() => navigate(AppRoutes.consultantList.path)}
                      className="adn-outlined-button"
                    >
                      {t("employeeFormDetails.buttons.goToConsultants")}
                    </Button>
                  </Col>
                  <Col>
                    {managerEditPermission && (
                      <Button
                        className="adn-primary-button"
                        type="submit"
                        onClick={() => setIsEditEnabled(!isEditEnabled)}
                      >
                        <EditOutlined /> {t("employeeFormDetails.buttons.edit")}
                      </Button>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </AdnCard>

          <AdnCard loading={loading}>
            <Row gutter={16}>
              <Col
                className={`tab-system ${
                  selectedTab === EmployeeTabs.Details ? "selected" : ""
                }`}
              >
                <AdnButton
                  handleClick={() => handleTabChange(EmployeeTabs.Details)}
                  text={t("employeeFormDetails.tabs.details")}
                />
              </Col>
              <Col
                className={`tab-system ${
                  selectedTab === EmployeeTabs.Certifications ? "selected" : ""
                }`}
              >
                <AdnButton
                  handleClick={() =>
                    handleTabChange(EmployeeTabs.Certifications)
                  }
                  text={t("employeeFormDetails.tabs.certifications")}
                />
              </Col>
              <Col
                className={`tab-system ${
                  selectedTab === EmployeeTabs.FollowupEvents ? "selected" : ""
                }`}
              >
                <AdnButton
                  handleClick={() =>
                    handleTabChange(EmployeeTabs.FollowupEvents)
                  }
                  text={t("employeeFormDetails.tabs.followUpEvents")}
                />
              </Col>
              <Col
                className={`tab-system ${
                  selectedTab === EmployeeTabs.Offers ? "selected" : ""
                }`}
              >
                <AdnButton
                  handleClick={() => handleTabChange(EmployeeTabs.Offers)}
                  text={t("employeeFormDetails.tabs.offers")}
                />
              </Col>
            </Row>

            <Divider />

            {criticalSituationsLinkPath !== undefined && (
              <Row style={{ marginBottom: "1rem" }}>
                <Col xs={{ span: 24 }} style={{ minHeight: "0" }}>
                  <CaptionComponent
                    text={t(
                      "employeeFormDetails.messages.criticalSituationsActive"
                    )}
                    status={1}
                    isBold={true}
                    textColor="#010A13"
                    linktext={t("employeeFormDetails.messages.checkItOut")}
                    link={criticalSituationsLinkPath}
                    openNewTab={true}
                  />
                </Col>
              </Row>
            )}

            {selectedTab === EmployeeTabs.Details && initialValues && (
              <>
                <Row className="employee-details">
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                  >
                    <Row style={{ marginBottom: "1rem" }}>
                      <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                      >
                        <Row className="detail-title" align="middle">
                          <Gift />
                          <p>{t("employeeFormDetails.labels.birthday")}</p>
                        </Row>
                        <Row className="detail-value">
                          <p>
                            {initialValues.birthDate
                              ? initialValues.birthDate.format("DD/MM/YYYY")
                              : "-"}
                          </p>
                        </Row>
                      </Col>
                      <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                      >
                        <Row className="detail-title" align="middle">
                          <User />
                          <p>{t("employeeFormDetails.labels.gender")}</p>
                        </Row>
                        <Row className="detail-value">
                          <p>{handleGender(initialValues.gender)}</p>
                        </Row>
                      </Col>
                    </Row>
                    {isConsultant ? (
                      <>
                        <Row style={{ marginBottom: "1rem" }}>
                          <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 12 }}
                          >
                            <Row className="detail-title" align="middle">
                              <Calendar />
                              <p>
                                {t("employeeFormDetails.labels.admissionDate")}
                              </p>
                            </Row>
                            <Row className="detail-value">
                              <p>
                                {initialValues.admissionDate
                                  ? initialValues.admissionDate.format(
                                      "DD/MM/YYYY"
                                    )
                                  : "-"}
                              </p>
                            </Row>
                          </Col>
                          <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 12 }}
                          >
                            <Row className="detail-title" align="middle">
                              <Hash />
                              <p>
                                {t(
                                  "employeeFormDetails.labels.consultantNumber"
                                )}
                              </p>
                            </Row>
                            <Row className="detail-value">
                              <p>{initialValues.number}</p>
                            </Row>
                          </Col>
                        </Row>
                        <Row style={{ marginBottom: "1rem" }}>
                          <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 12 }}
                          >
                            <Row className="detail-title" align="middle">
                              <Calendar />
                              <p>
                                {t("employeeFormDetails.labels.availableDate")}
                              </p>
                            </Row>
                            <Row className="detail-value">
                              <p>
                                {initialValues.availableDate
                                  ? initialValues.availableDate.format(
                                      "DD/MM/YYYY"
                                    )
                                  : "-"}
                              </p>
                            </Row>
                          </Col>
                          <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 12 }}
                          >
                            <Row>
                              <Row className="detail-title" align="middle">
                                <FileText />
                                <p>
                                  {t("employeeFormDetails.messages.contract")}
                                </p>
                              </Row>
                              <Button
                                style={{ marginLeft: "1rem" }}
                                className="adn-outlined-button"
                                onClick={() => handleShowHistoryModal()}
                              >
                                <HistoryOutlined />
                                {t("employeeFormDetails.messages.history")}
                              </Button>
                            </Row>
                            <Row className="detail-value">
                              <p>
                                {filteredContractTypes(
                                  initialValues.contractTypeId
                                )}
                              </p>
                            </Row>
                          </Col>
                        </Row>
                        <Row style={{ marginBottom: "1rem" }}>
                          <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 12 }}
                          >
                            <Row className="detail-title" align="middle">
                              <Calendar />
                              <p>
                                {t(
                                  "employeeFormDetails.messages.resignationDate"
                                )}
                              </p>
                            </Row>
                            <Row className="detail-value">
                              <p>
                                {initialValues.resignationDate
                                  ? initialValues.resignationDate.format(
                                      "DD/MM/YYYY"
                                    )
                                  : "-"}
                              </p>
                            </Row>
                          </Col>
                          <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 12 }}
                          >
                            <Row className="detail-title" align="middle">
                              <p>
                                {t(
                                  "employeeFormDetails.messages.resignationReason"
                                )}
                              </p>
                            </Row>
                            <Row className="detail-value">
                              <p>
                                {initialValues.resignationDate
                                  ? filteredResignationsReasons(initialValues)
                                  : "-"}
                              </p>
                            </Row>
                          </Col>
                          {initialValues.resignationDate && (
                            <Col
                              xs={{ span: 24 }}
                              sm={{ span: 24 }}
                              md={{ span: 24 }}
                              lg={{ span: 12 }}
                              xl={{ span: 12 }}
                            >
                              <Row className="detail-title" align="middle">
                                <p>
                                  {t(
                                    "employeeFormDetails.messages.dismissalComment"
                                  )}
                                </p>
                              </Row>
                              <Row className="detail-value">
                                <p>{initialValues.dismissalComment || "-"}</p>
                              </Row>
                            </Col>
                          )}
                        </Row>
                        <Row style={{ marginBottom: "1rem" }}>
                          <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 12 }}
                          >
                            <Row className="detail-title" align="middle">
                              <AtSign />
                              <p>
                                {t("employeeFormDetails.messages.referencedBy")}
                              </p>
                            </Row>
                            <Row className="detail-value">
                              <p>
                                {initialValues.referenceByName
                                  ? initialValues.referenceByName
                                  : "-"}
                              </p>
                            </Row>
                          </Col>
                          <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 12 }}
                          >
                            <Row className="detail-title" align="middle">
                              <Mail />
                              <p>
                                {t(
                                  "employeeFormDetails.messages.emailLanguage"
                                )}
                              </p>
                            </Row>
                            <Row className="detail-value">
                              <p>
                                {handleEmailLanguage(isEmailEnglishLanguage)}
                              </p>
                            </Row>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row style={{ marginBottom: "1rem" }}>
                          <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 12 }}
                          >
                            <Row className="detail-title" align="middle">
                              <Calendar />
                              <p>
                                {t("employeeFormDetails.labels.admissionDate")}
                              </p>
                            </Row>
                            <Row className="detail-value">
                              <p>
                                {initialValues.admissionDate
                                  ? initialValues.admissionDate.format(
                                      "DD/MM/YYYY"
                                    )
                                  : "-"}
                              </p>
                            </Row>
                          </Col>
                          <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 12 }}
                          >
                            <Row className="detail-title" align="middle">
                              <Hash />
                              <p>
                                {t(
                                  "employeeFormDetails.labels.consultantNumber"
                                )}
                              </p>
                            </Row>
                            <Row className="detail-value">
                              <p>{initialValues.number}</p>
                            </Row>
                          </Col>
                        </Row>
                        <Row style={{ marginBottom: "1rem" }}>
                          <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 12 }}
                          >
                            <Row className="detail-title" align="middle">
                              <AtSign />
                              <p>
                                {t("employeeFormDetails.messages.referencedBy")}
                              </p>
                            </Row>
                            <Row className="detail-value">
                              <p>
                                {initialValues.referenceByName
                                  ? initialValues.referenceByName
                                  : "-"}
                              </p>
                            </Row>
                          </Col>
                          <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 12 }}
                          >
                            <Row className="detail-title" align="middle">
                              <Calendar />
                              <p>
                                {t(
                                  "employeeFormDetails.messages.resignationDate"
                                )}
                              </p>
                            </Row>
                            <Row className="detail-value">
                              <p>
                                {initialValues.resignationDate
                                  ? initialValues.resignationDate.format(
                                      "DD/MM/YYYY"
                                    )
                                  : "-"}
                              </p>
                            </Row>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                  >
                    <Col
                      style={{ marginBottom: "1rem" }}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 24 }}
                      xl={{ span: 24 }}
                    >
                      <Row className="detail-title" align="middle">
                        <Mail />
                        <p>{t("employeeFormDetails.messages.email")}</p>
                      </Row>
                      <Row className="detail-value">
                        <p>{initialValues.email}</p>
                      </Row>
                    </Col>
                    {isConsultant ? (
                      <Row style={{ marginBottom: "1rem" }}>
                        <Col
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 24 }}
                          lg={{ span: 8 }}
                          xl={{ span: 8 }}
                        >
                          <Row className="detail-title" align="middle">
                            <Phone />
                            <p>{t("employeeFormDetails.messages.phone1")}</p>
                          </Row>
                          <Row className="detail-value">
                            <p>
                              {initialValues.phone ? initialValues.phone : "-"}
                            </p>
                          </Row>
                        </Col>
                        <Col
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 24 }}
                          lg={{ span: 8 }}
                          xl={{ span: 8 }}
                        >
                          <Row className="detail-title" align="middle">
                            <Phone />
                            <p>{t("employeeFormDetails.messages.phone2")}</p>
                          </Row>
                          <Row className="detail-value">
                            <p>
                              {initialValues.phone2
                                ? initialValues.phone2
                                : "-"}
                            </p>
                          </Row>
                        </Col>
                        <Col
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 24 }}
                          lg={{ span: 8 }}
                          xl={{ span: 8 }}
                        >
                          <Row className="detail-title" align="middle">
                            <Map />
                            <p>
                              {t("employeeFormDetails.messages.nationality")}
                            </p>
                          </Row>
                          <Row className="detail-value">
                            <p>
                              {filteredCountry(initialValues.nationalityId)}
                            </p>
                          </Row>
                        </Col>
                      </Row>
                    ) : (
                      <Row style={{ marginBottom: "1rem" }}>
                        <Col
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 24 }}
                          lg={{ span: 8 }}
                          xl={{ span: 8 }}
                        >
                          <Row className="detail-title" align="middle">
                            <Phone />
                            <p>{t("employeeFormDetails.messages.phone1")}</p>
                          </Row>
                          <Row className="detail-value">
                            <p>
                              {initialValues.phone ? initialValues.phone : "-"}
                            </p>
                          </Row>
                        </Col>
                        <Col
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 24 }}
                          lg={{ span: 8 }}
                          xl={{ span: 8 }}
                        >
                          <Row className="detail-title" align="middle">
                            <Phone />
                            <p>{t("employeeFormDetails.messages.phone2")}</p>
                          </Row>
                          <Row className="detail-value">
                            <p>
                              {initialValues.phone2
                                ? initialValues.phone2
                                : "-"}
                            </p>
                          </Row>
                        </Col>
                        <Col
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 24 }}
                          lg={{ span: 8 }}
                          xl={{ span: 8 }}
                        >
                          <Row className="detail-title" align="middle">
                            <Map />
                            <p>
                              {t("employeeFormDetails.messages.nationality")}
                            </p>
                          </Row>
                          <Row className="detail-value">
                            <p>
                              {filteredCountry(initialValues.nationalityId)}
                            </p>
                          </Row>
                        </Col>
                      </Row>
                    )}

                    <Row style={{ marginBottom: "1rem" }}>
                      {isConsultant && (
                        <Col
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 24 }}
                          lg={{ span: 12 }}
                          xl={{ span: 12 }}
                        >
                          <Row className="detail-title" align="middle">
                            <AtSign />
                            <p>{t("employeeFormDetails.messages.manager")}</p>
                          </Row>
                          {/* <Row className="detail-value"><a href={`/consultant/${initialValues.managerId}`}>{filteredManagers(initialValues.managerId)}</a></Row>FIX ME */}
                          <Row className="detail-value">
                            <p>{filteredManagers(initialValues.managerId)}</p>
                          </Row>
                        </Col>
                      )}
                      <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                      >
                        <Row className="detail-title" align="middle">
                          <MapPin />
                          <p>{t("employeeFormDetails.messages.location")}</p>
                        </Row>
                        <Row className="detail-value">
                          <p>{filteredLocations(initialValues.workPlaceId)}</p>
                        </Row>
                      </Col>
                    </Row>
                    {isConsultant && (
                      <>
                        <Row style={{ marginBottom: "1rem" }}>
                          <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 12 }}
                          >
                            <Row className="detail-title" align="middle">
                              <TrendingUp />
                              <p>
                                {t("employeeFormDetails.messages.careerLevel")}
                              </p>
                            </Row>
                            <Row className="detail-value">
                              <p>
                                {filteredCareerLevels(
                                  initialValues.carrearLevelId
                                )}
                              </p>
                            </Row>
                          </Col>
                          <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 12 }}
                          >
                            <Row className="detail-title" align="middle">
                              <Briefcase />
                              <p>
                                {t(
                                  "employeeFormDetails.messages.currentClient"
                                )}
                              </p>
                            </Row>
                            <Row className="detail-value">
                              <p>{initialValues.currentCompany}</p>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Row className="detail-title" align="middle">
                              <Users />
                              <p>
                                {t("employeeFormDetails.messages.department")}
                              </p>
                            </Row>
                            <Row className="detail-value">
                              <p>
                                {initialValues.departmentId ===
                                Departement.NeXel
                                  ? "NeXel"
                                  : "-"}
                              </p>
                            </Row>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Col>
                </Row>
                {isConsultant && (
                  <>
                    <Row>
                      <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                      >
                        <Row className="detail-title">
                          <p>{t("employeeFormDetails.messages.notes")}</p>
                        </Row>
                        <Row className="detail-value">
                          <p>{initialValues.note ? initialValues.note : "-"}</p>
                        </Row>
                      </Col>
                    </Row>

                    <Row style={{ margin: "1rem 0" }}>
                      <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                      >
                        <Row className="detail-title">
                          <p>
                            {t("employeeFormDetails.messages.technologies")}
                          </p>
                        </Row>
                        <Row className="detail-value">
                          {tags[0] === undefined ? (
                            <p>-</p>
                          ) : (
                            tags.map((tag, index) => {
                              if (editTagInputIndex === index) {
                                return (
                                  <Input
                                    ref={tagEditInputRef}
                                    key={tag}
                                    size="small"
                                    className="tag-input"
                                    value={editTagInputValue}
                                    onChange={handleTagEditInputChange}
                                    onBlur={handleTagEditInputConfirm}
                                    onPressEnter={handleTagEditInputConfirm}
                                  />
                                );
                              }
                              const isLongTag = tag.length > 20;
                              const tagElem = (
                                <Tag
                                  color="green"
                                  className="edit-tag"
                                  key={tag}
                                  closable={isEditEnabled}
                                  onClose={() => handleCloseTag(tag)}
                                >
                                  <span
                                    onDoubleClick={(e) => {
                                      setTagEditInputIndex(index);
                                      setTagEditInputValue(tag);
                                      e.preventDefault();
                                    }}
                                  >
                                    {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                                  </span>
                                </Tag>
                              );
                              return isLongTag ? (
                                <Tooltip title={tag} key={tag}>
                                  {tagElem}
                                </Tooltip>
                              ) : (
                                tagElem
                              );
                            })
                          )}
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                      >
                        <Row className="detail-title">
                          <p>{t("employeeFormDetails.messages.hrActions")}</p>
                        </Row>
                      </Col>
                      <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 6 }}
                        xl={{ span: 6 }}
                      >
                        <Row className="detail-value" align="middle">
                          {isIntegrationEmailSent === 1 ? (
                            <>
                              <CheckCircleOutlined className="action-svg" />
                            </>
                          ) : (
                            isEmailSending && (
                              <>
                                <EllipsisOutlined className="action-svg" />
                              </>
                            )
                          )}
                          <p>
                            {t("employeeFormDetails.messages.integrationEmail")}
                          </p>
                        </Row>
                      </Col>
                      {settingProfileEmailActive.value === "TRUE" && (
                        <Col
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 24 }}
                          lg={{ span: 6 }}
                          xl={{ span: 6 }}
                        >
                          <Row className="detail-value" align="middle">
                            {isProfileEmailSent ? (
                              <>
                                <CheckCircleOutlined className="action-svg" />
                              </>
                            ) : (
                              isEmailSending && (
                                <>
                                  <EllipsisOutlined className="action-svg" />
                                </>
                              )
                            )}
                            <p>
                              {t("employeeFormDetails.messages.profileEmail")}
                            </p>
                          </Row>
                        </Col>
                      )}
                      <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 6 }}
                        xl={{ span: 6 }}
                      >
                        <Row className="detail-value" align="middle">
                          {isFirstMonthAssessmentEmailSent ? (
                            <>
                              <CheckCircleOutlined className="action-svg" />
                            </>
                          ) : (
                            isEmailSending && (
                              <>
                                <EllipsisOutlined className="action-svg" />
                              </>
                            )
                          )}
                          {!isFirstMonthAssessmentEmailSent ? (
                            <p style={{ color: "var(--adngrey)" }}>
                              {t(
                                "employeeFormDetails.messages.firstMonthAssessment"
                              )}
                            </p>
                          ) : (
                            <p>
                              {t(
                                "employeeFormDetails.messages.firstMonthAssessment"
                              )}
                            </p>
                          )}
                        </Row>
                      </Col>
                      <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 6 }}
                        xl={{ span: 6 }}
                        xxl={{ span: 6 }}
                      >
                        <Row className="detail-value" align="middle">
                          {initialValues.hasCorpDone && (
                            <>
                              <CheckCircleOutlined className="action-svg" />
                            </>
                          )}
                          {!initialValues.hasCorpDone ? (
                            <p style={{ color: "var(--adngrey)" }}>
                              {t("employeeFormDetails.messages.corp")}
                            </p>
                          ) : (
                            <p>{t("employeeFormDetails.messages.corp")}</p>
                          )}
                        </Row>
                      </Col>
                    </Row>
                  </>
                )}
              </>
            )}
            {selectedTab === EmployeeTabs.Certifications && (
              <>
                <AdnCertificationTable
                  employeeCertificationData={employeeCertificationData}
                  employee={employeeId}
                  admissionDate={initialValues?.admissionDate}
                ></AdnCertificationTable>
              </>
            )}
            {selectedTab === EmployeeTabs.FollowupEvents && (
              <>
                <Row>
                  <Col span={24}>
                    <AdnTable
                      columns={followUpEventsColumns}
                      data={employeeFollowUpEventData}
                      pageSize={adnPageSize}
                      totalRecords={totalRecordsFollowUp}
                      handleChangePage={handleChangeFollowUpPage}
                      expandable={(record) => (
                        <>
                          <p style={{ margin: 0 }}>
                            <b>
                              {t("employeeFormDetails.messages.notesLabel")}
                            </b>{" "}
                            {record.note}
                          </p>
                          <p style={{ margin: 0 }}>
                            <b>
                              {t("employeeFormDetails.messages.feedbackLabel")}
                            </b>{" "}
                            {record.feedBack}
                          </p>
                        </>
                      )}
                      rowClassName={(record, index) =>
                        moment(record.referenceDate).add(30, "d") <
                          moment(moment()) &&
                        (record.status === 0 || record.status === 1)
                          ? "lateEventRow"
                          : ""
                      }
                    />
                    <Modal
                      title={t(
                        "employeeFormDetails.modals.cancelFollowUpEvent"
                      )}
                      open={cancelEventVisible}
                      onOk={cancelEventForm.submit}
                      onCancel={() => {
                        cancelEventForm.resetFields();
                        setCancelEventVisible(false);
                      }}
                      footer={[
                        <Button
                          className="adn-outlined-button"
                          key="back"
                          onClick={() => setCancelEventVisible(false)}
                        >
                          {t("employeeFormDetails.buttons.back")}
                        </Button>,
                        <Button
                          key="ok"
                          type="primary"
                          onClick={cancelEventForm.submit}
                          className="adn-primary-button primary-cancel"
                        >
                          {t("employeeFormDetails.buttons.cancelEvent")}
                        </Button>,
                      ]}
                    >
                      <Form
                        form={cancelEventForm}
                        name="form_in_modal"
                        layout="vertical"
                        onFinish={handleCancelEventFinish}
                      >
                        <p>
                          {" "}
                          {t(
                            "employeeFormDetails.modals.cancelEventConfirmation"
                          )}{" "}
                        </p>
                        <p>
                          {" "}
                          {t(
                            "employeeFormDetails.modals.cancelEventNotes"
                          )}{" "}
                        </p>
                        <AdnInput
                          name={"note"}
                          placeholder={t(
                            "employeeFormDetails.modals.insertNotes"
                          )}
                          maxLength={500}
                          rules={[
                            {
                              required: true,
                              message: t(
                                "employeeFormDetails.modals.fieldRequired"
                              ),
                            },
                          ]}
                        />
                      </Form>
                    </Modal>
                    <Modal
                      title={t(
                        "employeeFormDetails.messages.undoFollowUpEvents"
                      )}
                      open={unresolvedModalVisible}
                      onOk={() => {
                        confirmAssignPerson(eventEmployeeId, eventAssignedToId);
                        setUnresolvedModalVisible(false);
                      }}
                      okText={t("employeeFormDetails.messages.yes")}
                      onCancel={() => {
                        setUnresolvedModalVisible(false);
                      }}
                      cancelText={t("employeeFormDetails.messages.no")}
                    >
                      {t("employeeFormDetails.messages.previousUndoneEvents")}{" "}
                      <br />
                      <br></br>
                      <u>
                        {t("employeeFormDetails.messages.assignEventAnyway")}
                      </u>
                    </Modal>
                  </Col>
                </Row>
              </>
            )}
            {selectedTab === EmployeeTabs.Offers && (
              <>
                {!isManager && (
                  <Row>
                    <Col span={24}>
                      <AdnAddButton
                        style={{ float: "right" }}
                        name="Offer"
                        handleClick={() => {
                          setEvent("Add");
                          getOfferListData();
                          setVisibleModalOffer(true);
                          setOfferHandler([]);
                          formOffers.setFieldsValue({
                            offeredAt: "",
                            note: "",
                            typeId: undefined,
                            description: "",
                          });
                        }}
                      />
                    </Col>
                  </Row>
                )}
                <Row className="offersDatePicker">
                  <Col span={24}>
                    <AdnTable
                      columns={offerColumns}
                      data={employeeOfferData}
                      expandable={(record) => (
                        <>
                          <p style={{ margin: 0 }}>
                            <b>
                              {t("employeeFormDetails.messages.notesLabel")}
                            </b>{" "}
                            {record.note}
                          </p>
                        </>
                      )}
                      rowClassName={(record, index) =>
                        moment(record.referenceDate).add(30, "d") <
                          moment(moment()) && record.status === 0
                          ? "lateEventRow"
                          : ""
                      }
                    />
                  </Col>
                </Row>
              </>
            )}
          </AdnCard>
        </>
      ) : (
        <AdnCard>
          {!isEditing && (
            <Row>
              <Col span={5}>
                <Form layout="vertical">
                  <AdnDropdown
                    label={t("employeeFormDetails.consultantType.label")}
                    placeholder={t(
                      "employeeFormDetails.consultantType.placeholder"
                    )}
                    handleChange={onIsConsultantChange}
                    defaultValue={isConsultant ? "consultant" : "internal"}
                    options={[
                      {
                        id: "consultant",
                        name: t(
                          "employeeFormDetails.consultantType.consultant"
                        ),
                      },
                      {
                        id: "internal",
                        name: t("employeeFormDetails.consultantType.internal"),
                      },
                    ]}
                  />
                </Form>
              </Col>
            </Row>
          )}
          <br />
          {isConsultant ? (
            <EmployeeConsultantDetailsForm
              setFluencyLanguages={setFluencyLanguages}
              employeeId={employeeId}
              setIsEditEnabled={setIsEditEnabled}
              employeeFollowUpEventsCounters={employeeFollowUpEventsCounters}
              form={consultantForm}
              hasResignationDate={hasResignationDate}
              handleResignationDateChange={handleResignationDateChange}
              careerLevels={careerLevels}
              handleContractType={handleContractType}
              contractTypeList={contractTypeList}
              managersList={managersList}
              humanResList={humanResList}
              renderIfTemplateQuestionLoaded={renderIfTemplateQuestionLoaded}
              selectedTemplateId={selectedTemplateId}
              onTemplateChangeHandle={onTemplateChangeHandle}
              templates={templates}
              onQuestion1Change={onQuestion1Change}
              onQuestion2Change={onQuestion2Change}
              onQuestion3Change={onQuestion3Change}
              onQuestion4Change={onQuestion4Change}
              onQuestion5Change={onQuestion5Change}
              onQuestion6Change={onQuestion6Change}
              isSentInquiryEmail={isSentInquiryEmail}
              isEditing={isEditing}
              isInquiryAnswered={isInquiryAnswered}
              onFinish={onFormFinish}
              initialValues={initialValues}
              disabledDateBirthDate={disabledDateBirthDate}
              openEmailModal={openEmailModal}
              templateAlreadySelected={templateAlreadySelected}
              workPlaceList={workPlaceList}
              countryList={countryList}
              image={image}
              saveImage={saveImage}
              haveAdmissionCti={haveAdmissionCti}
              handleChangeToCti={handleChangeToCti}
              isCTI={isCTI}
              handleBlurEmail={handleBlurEmail}
              handleBlurName={handleBlurName}
              isIntegrationEmailSent={isIntegrationEmailSent}
              isProfileEmailSent={isProfileEmailSent}
              submitLoading={submitLoading}
              imgLoading={imgLoading}
              haveAdmissionCps={haveAdmissionCps}
              handleSearchReferenceBy={handleSearchReferenceBy}
              handleSelectReferenceBy={handleSelectReferenceBy}
              referenceByEmployees={referenceByEmployees}
              referenceByName={referenceByName}
              handleAward={handleAward}
              isFirstAwardPaid={isFirstAwardPaid}
              isSecondAwardPaid={isSecondAwardPaid}
              handleFirstAward={handleFirstAward}
              handleSecondAward={handleSecondAward}
              referenceByBlur={referenceByBlur}
              tags={tags}
              tagInputRef={tagInputRef}
              tagEditInputRef={tagEditInputRef}
              tagInputVisible={tagInputVisible}
              tagInputValue={tagInputValue}
              editTagInputIndex={editTagInputIndex}
              editTagInputValue={editTagInputValue}
              setTagEditInputIndex={setTagEditInputIndex}
              setTagEditInputValue={setTagEditInputValue}
              handleCloseTag={handleCloseTag}
              showTagInput={showTagInput}
              handleTagInputChange={handleTagInputChange}
              handleTagInputConfirm={handleTagInputConfirm}
              handleTagEditInputChange={handleTagEditInputChange}
              handleTagEditInputConfirm={handleTagEditInputConfirm}
              isEmailEnglishLanguages={isEmailEnglishLanguages}
              setisEmailEnglishLanguages={setisEmailEnglishLanguages}
              isEmailSending={isEmailSending}
              isFirstMonthAssessmentEmailSent={isFirstMonthAssessmentEmailSent}
              isFirstMonthAssessmentAnswered={isFirstMonthAssessmentAnswered}
              isEditEnabled={isEditEnabled}
              disableEdit={disableEdit}
              saveEditChanges={saveEditChanges}
              handleTransition={handleTransition}
              inTransition={inTransition}
              techSpecializedList={techSpecializedList}
              techSpecializedName={techSpecializedName}
              resignationReasonOptions={resignationReasonOptions}
              handleShowHistoryModal={handleShowHistoryModal}
              fluencyLanguages={fluencyLanguages}
              firstMonthAssessmentQuestions={firstMonthAssessmentQuestions}
              submitInquiry={submitInquiry}
              handleChangeTechSpecializedName={handleChangeTechSpecializedName}
              inquiryForm={inquiryForm}
              isManager={isManager}
              hasCorpDepartureReason={hasCorpDepartureReason}
              departmentList={departmentList}
            />
          ) : (
            <EmployeeInternalDetailsForm
              disableEdit={disableEdit}
              setIsEditEnabled={setIsEditEnabled}
              onFinish={onFormFinish}
              initialValues={initialValues}
              form={consultantForm}
              hasResignationDate={hasResignationDate}
              handleResignationDateChange={handleResignationDateChange}
              disabledDateBirthDate={disabledDateBirthDate}
              workPlaceList={workPlaceList}
              image={image}
              saveImage={saveImage}
              handleAward={handleAward}
              isFirstAwardPaid={isFirstAwardPaid}
              isSecondAwardPaid={isSecondAwardPaid}
              handleFirstAward={handleFirstAward}
              handleSecondAward={handleSecondAward}
              isEditing={isEditing}
              handleBlurEmail={handleBlurEmail}
              handleBlurName={handleBlurName}
              submitLoading={submitLoading}
              imgLoading={imgLoading}
              countryList={countryList}
              handleSearchReferenceBy={handleSearchReferenceBy}
              handleSelectReferenceBy={handleSelectReferenceBy}
              referenceByEmployees={referenceByEmployees}
              referenceByName={referenceByName}
              referenceByBlur={referenceByBlur}
              isEditEnabled={isEditEnabled}
              saveEditChanges={saveEditChanges}
              resignationReasonOptions={resignationReasonOptions}
              employeeFollowUpEventsCounters={employeeFollowUpEventsCounters}
              isManager={isManager}
              hasCorpDepartureReason={hasCorpDepartureReason}
            />
          )}
        </AdnCard>
      )}
      <Modal
        title={t("employeeFormDetails.modals.cancelRecommendationBenefits")}
        open={visibleCancelRecommendationsModal}
        onOk={handleCancelUnpaidRecommendations}
        okText={t("employeeFormDetails.buttons.cancelBenefits")}
        cancelText={t("employeeFormDetails.buttons.no")}
        onCancel={(e) => setVisibleCancelRecommendationsModal(false)}
      >
        <p>{t("employeeFormDetails.modals.unpaidBenefits")}</p>
        <p>{t("employeeFormDetails.modals.cancelThem")}</p>
      </Modal>

      <Modal
        title={t("employeeFormDetails.modals.cancelOffer")}
        open={cancelOfferVisible}
        onOk={cancelOfferForm.submit}
        onCancel={() => {
          cancelOfferForm.resetFields();
          setCancelOfferVisible(false);
        }}
        footer={[
          <Button
            className="adn-outlined-button"
            key="cancel"
            onClick={() => setCancelOfferVisible(false)}
          >
            {t("employeeFormDetails.buttons.no")}
          </Button>,
          <Button
            key="ok"
            type="primary"
            onClick={cancelOfferForm.submit}
            className="adn-primary-button primary-cancel"
          >
            {t("employeeFormDetails.buttons.cancelOffer")}
          </Button>,
        ]}
      >
        <Form
          form={cancelOfferForm}
          name="form_in_modal"
          layout="vertical"
          onFinish={() => handleChangeOffer(offerFormValues, 2)}
        >
          <p> {t("employeeFormDetails.modals.cancelEventConfirmation")} </p>
          <p> {t("employeeFormDetails.modals.cancelEventNotes")} </p>
          <AdnInput
            name={"note"}
            placeholder={t("employeeFormDetails.modals.insertNotes")}
            maxLength={500}
            rules={[
              {
                required: true,
                message: t("employeeFormDetails.modals.fieldRequired"),
              },
            ]}
          />
        </Form>
      </Modal>

      <Modal
        title={
          event === "Add"
            ? t("employeeFormDetails.modals.newOffer")
            : t("employeeFormDetails.modals.editOffer")
        }
        open={visibleModalOffer}
        onOk={formOffers.submit}
        okText={t("employeeFormDetails.buttons.save")}
        cancelText={t("employeeFormDetails.buttons.back")}
        onCancel={onCancelOffersModal}
        confirmLoading={modalSubmitLoading}
      >
        <Form
          form={formOffers}
          name="form_in_modal"
          layout="vertical"
          onFinish={handleFormOffer}
        >
          {event === "Add" ? (
            <AdnDropdown
              options={offerData}
              name={"typeId"}
              label={t("employeeFormDetails.messages.name")}
              placeholder={t(
                "employeeFormDetails.placeholders.chooseOfferName"
              )}
              rules={NameValidation}
            />
          ) : (
            <AdnInput
              name={"offerName"}
              label={t("employeeFormDetails.messages.name")}
              placeholder={t(
                "employeeFormDetails.placeholders.chooseOfferName"
              )}
              readOnly={true}
              rules={NameValidation}
            />
          )}
          <AdnInput
            name={"description"}
            label={t("employeeFormDetails.labels.description")}
            readOnly={event === "Add" ? false : true}
            placeholder={t(
              "employeeFormDetails.placeholders.insertDescription"
            )}
            rules={NoteValidation}
            maxLength={60}
          />
          <AdnDatePicker
            name={"offeredAt"}
            label={t("employeeFormDetails.labels.offeredAt")}
            placeholder={t("employeeFormDetails.placeholders.selectDate")}
            disabledDate={disabledDateOffer}
            format={dateFormat}
          />
          <AdnTextArea
            name={"note"}
            label={t("employeeFormDetails.labels.note")}
            placeholder={t("employeeFormDetails.placeholders.insertNote")}
            rules={NoteValidation}
            maxLength={500}
          />
        </Form>
      </Modal>

      <Modal
        title={t("employeeFormDetails.modals.contractHistory")}
        width={1500}
        open={showContractHistoryModal}
        okCancel="Back"
        onCancel={handleCloseContractHistoryModal}
        footer={[
          <Button key="back" onClick={handleCloseContractHistoryModal}>
            {t("employeeFormDetails.buttons.back")}
          </Button>,
        ]}
      >
        <AdnTable
          columns={constractHistoryColumns}
          data={employeeContractHistory}
          showPagination={false}
        />
      </Modal>
    </>
  );
}

export default EmployeeForm;
